// ExportService.js
const ExportService = {
  generateMarkdown: (conversation, summary, insights, header = 'Voice Journal') => {
    const date = new Date().toLocaleDateString();
    const time = new Date().toLocaleTimeString();
    
    return `# ${header}

**Date:** ${date}  
**Time:** ${time}  
**Messages:** ${conversation.length}

---

## Summary

${summary}

${insights ? `

## Emotional Insights

${insights}

` : ''}

---

## Full Conversation

${conversation
  .filter(msg => msg.type !== 'system')
  .map(msg => {
    const timestamp = msg.timestamp ? new Date(msg.timestamp).toLocaleTimeString() : '';
    const speaker = msg.type === 'user' ? '**You**' : '**Assistant**';
    return `${speaker} *${timestamp}*  
> ${msg.content}`;
  })
  .join('\n\n')}

---

*Generated on ${date} at ${time}*`;
  },
  
  downloadAsFile: (content, filename, type = 'text/markdown') => {
    const blob = new Blob([content], { type });
    const url = URL.createObjectURL(blob);
    const a = document.createElement('a');
    a.href = url;
    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  },
  
  copyToClipboard: async (text) => {
    try {
      if (navigator.clipboard && window.isSecureContext) {
        await navigator.clipboard.writeText(text);
        return true;
      } else {
        // Fallback for non-secure contexts
        const textArea = document.createElement('textarea');
        textArea.value = text;
        textArea.style.position = 'absolute';
        textArea.style.left = '-999999px';
        document.body.appendChild(textArea);
        textArea.focus();
        textArea.select();
        try {
          const successful = document.execCommand('copy');
          document.body.removeChild(textArea);
          return successful;
        } catch (err) {
          document.body.removeChild(textArea);
          return false;
        }
      }
    } catch (err) {
      console.error('Failed to copy to clipboard:', err);
      return false;
    }
  },

  // Export as JSON format
  exportAsJSON: (conversation, summary, insights, header) => {
    const exportData = {
      header: header || 'Voice Journal Entry',
      timestamp: new Date().toISOString(),
      summary,
      insights,
      conversation: conversation.filter(msg => msg.type !== 'system'),
      metadata: {
        messageCount: conversation.length,
        exportedAt: new Date().toISOString(),
        version: '1.0'
      }
    };
    
    return JSON.stringify(exportData, null, 2);
  },

  // Export as plain text
  exportAsText: (conversation, summary, insights, header) => {
    const date = new Date().toLocaleDateString();
    const time = new Date().toLocaleTimeString();
    
    let content = `${header || 'Voice Journal Entry'}\n`;
    content += `${'='.repeat(header?.length || 20)}\n\n`;
    content += `Date: ${date}\n`;
    content += `Time: ${time}\n`;
    content += `Messages: ${conversation.length}\n\n`;
    
    if (summary) {
      content += `Summary:\n${'-'.repeat(8)}\n${summary}\n\n`;
    }
    
    if (insights) {
      content += `Emotional Insights:\n${'-'.repeat(18)}\n${insights}\n\n`;
    }
    
    content += `Full Conversation:\n${'-'.repeat(17)}\n`;
    
    conversation
      .filter(msg => msg.type !== 'system')
      .forEach(msg => {
        const timestamp = msg.timestamp ? new Date(msg.timestamp).toLocaleTimeString() : '';
        const speaker = msg.type === 'user' ? 'You' : 'Assistant';
        content += `\n[${timestamp}] ${speaker}:\n${msg.content}\n`;
      });
    
    content += `\n---\nGenerated on ${date} at ${time}`;
    
    return content;
  },

  // Get appropriate filename based on header and date
  getFilename: (header, format = 'md') => {
    const date = new Date().toISOString().split('T')[0];
    const cleanHeader = (header || 'voice-journal')
      .toLowerCase()
      .replace(/[^a-z0-9\s-]/g, '')
      .replace(/\s+/g, '-')
      .substring(0, 30);
    
    return `${cleanHeader}-${date}.${format}`;
  }
};

export default ExportService;